import { GraphQLClient } from 'graphql-request';
import gql from 'graphql-tag';
export const AutomationRunListFieldsFragmentDoc = gql`
    fragment AutomationRunListFields on JobExecution {
  id
  status
  errorMessage
  jobName
  automationId
  checkInId
  sectionId
  createdAt
  retriedAt
  guestEmail
  queueType
  summary
  outcome
  recipient
  pcoProfileUrl
  pcoWorkflowUrl
  values {
    label
    value
  }
  automation {
    id
    label
    type
    integrationSource
  }
  guest {
    id
    firstName
    lastName
    email
  }
}
    `;
export const AutomationRunDetailFieldsFragmentDoc = gql`
    fragment AutomationRunDetailFields on JobExecution {
  startedAt
  finishedAt
  durationMs
  progressLog {
    step
    status
    reason
    timestamp
  }
}
    `;
export const AutomationRunFieldsFragmentDoc = gql`
    fragment AutomationRunFields on JobExecution {
  ...AutomationRunListFields
  ...AutomationRunDetailFields
}
    ${AutomationRunListFieldsFragmentDoc}
${AutomationRunDetailFieldsFragmentDoc}`;
export const BasicSectionFragmentDoc = gql`
    fragment BasicSection on Section {
  id
  name
  type
  text
  courseId
  settings
  order
  parentId
  inputs(orderBy: {order: asc}) {
    id
    type
    label
    required
    placeholder
    options
    order
  }
  questions(orderBy: {timecode: asc}) {
    id
    timecode
    message
    record
    type
  }
  childSections(orderBy: {order: asc}) {
    id
    name
    type
  }
  subSections(orderBy: {order: asc}) {
    id
    label
    text
    order
    goTo
  }
  parentSection {
    id
    order
    type
    courseId
  }
  goToCourses(orderBy: {order: asc}) {
    id
    label
    text
    order
    courseId
  }
}
    `;
 const MeDocument = gql`
    query me {
  user: me {
    id
    firstName
    lastName
    email
    super
    churches(where: {NOT: {churchId: {equals: "CHURCH_ID"}}}) {
      church {
        id
        name
        icon
      }
    }
  }
  church: findUniqueChurch(where: {id: "CHURCH_ID"}) {
    id
    name
    icon
    logo
    url
    buttonTextColor
    buttonColor
    bannerColor
    buttonStyle
    bannerStyle
    customer
    integrations {
      id
      type
      settings
      cachedData
    }
  }
  billing: getAllBillingData {
    plan
    status
  }
}
    `;
 const GuestChurchDocument = gql`
    query guestChurch($sectionId: String) {
  courseBranding: guestCourseBranding
  checkIn: findUniqueCheckIn(where: {id: "CHECKIN_ID"}) {
    id
    courseId
    adminCheckIn
    sectionId
    startedAt
    submissions(where: {sectionId: {equals: $sectionId}}) {
      id
      data
    }
    guest {
      id
      firstName
      lastName
      email
    }
  }
  church: findUniqueChurch(where: {id: "GUEST_CHURCH_ID"}) {
    id
    name
    logo
    icon
    url
    buttonTextColor
    buttonColor
    bannerColor
    buttonStyle
    bannerStyle
    customer
    integrations {
      id
      type
      settings
      cachedData
    }
  }
}
    `;
 const GuestDataDocument = gql`
    query guestData($courseId: String, $admin: Boolean!, $startedAt: DateTime) {
  guest: findUniqueGuest(where: {id: "GUEST_ID"}) {
    id
    firstName
    lastName
    phone
    email
    integrationInfo
  }
  guestCourse: findManyHistoricalCourse(
    where: {id: {equals: $courseId}, validity_lower: {lte: $startedAt}, validity_upper: {gte: $startedAt}}
  ) @skip(if: $admin) {
    id
    name
    url
    sections(orderBy: {order: asc}) {
      id
      name
      order
      type
      parentId
    }
  }
  adminCourse: findUniqueCourse(where: {id: $courseId}) @include(if: $admin) {
    id
    name
    url
    sections(orderBy: {order: asc}) {
      id
      name
      order
      type
      parentId
    }
  }
}
    `;
 const AppSectionDocument = gql`
    query appSection($sectionId: String!, $churchId: String) {
  guest: guest(sectionId: $sectionId) {
    currentSection {
      id
      name
      type
      text
      courseId
      settings
      order
      parentId
      inputs(orderBy: {order: asc}) {
        id
        type
        label
        required
        placeholder
        options
        order
      }
      questions(orderBy: {timecode: asc}) {
        id
        timecode
        message
        record
        type
      }
      subSections(orderBy: {order: asc}) {
        id
        label
        text
        order
        goTo
      }
      goToCourses(orderBy: {order: asc}) {
        id
        label
        text
        order
        courseId
      }
    }
    course {
      id
      name
      url
      public
      description
      sections(orderBy: {order: asc}) {
        id
        name
        order
        type
        parentId
      }
    }
    teamsChosenElsewhere
  }
  activeSubscription: activeSubscription(churchId: $churchId) {
    start
    end
  }
}
    `;
 const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  data: login(email: $email, password: $password) {
    token
  }
}
    `;
 const SignupDocument = gql`
    mutation signup($data: UserCreateInput!) {
  data: signup(data: $data) {
    token
  }
}
    `;
 const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  data: forgotPassword(email: $email) {
    message
  }
}
    `;
 const CaptureLeadDocument = gql`
    mutation captureLead($email: String!, $firstName: String, $lastName: String, $phone: String, $churchName: String, $attribution: AttributionInput) {
  data: captureLead(
    email: $email
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    churchName: $churchName
    attribution: $attribution
  ) {
    leadId
  }
}
    `;
 const CompleteOnboardingDocument = gql`
    mutation completeOnboarding($churchName: String!, $email: String!, $state: String!, $firstName: String, $lastName: String, $phone: String, $size: String, $leadId: String, $referralCode: String, $attribution: AttributionInput) {
  data: completeOnboarding(
    churchName: $churchName
    email: $email
    state: $state
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    size: $size
    leadId: $leadId
    referralCode: $referralCode
    attribution: $attribution
  ) {
    token
  }
}
    `;
 const RequestMagicLinkDocument = gql`
    mutation requestMagicLink($email: String!) {
  data: requestMagicLink(email: $email) {
    message
  }
}
    `;
 const RequestMagicLinkToDocument = gql`
    mutation requestMagicLinkTo($email: String!, $to: String!) {
  data: requestMagicLink(email: $email, to: $to) {
    message
  }
}
    `;
 const LoginWithMagicLinkDocument = gql`
    mutation loginWithMagicLink($token: String!) {
  data: loginWithMagicLink(token: $token) {
    token
  }
}
    `;
 const SendDesktopLinkDocument = gql`
    mutation sendDesktopLink($courseId: String, $sectionId: String) {
  data: sendDesktopLink(courseId: $courseId, sectionId: $sectionId) {
    message
  }
}
    `;
 const ResetPasswordDocument = gql`
    mutation resetPassword($data: UserUpdateInput!, $resetPasswordToken: String!) {
  data: resetPassword(data: $data, resetPasswordToken: $resetPasswordToken) {
    token
  }
}
    `;
 const UpdatePasswordDocument = gql`
    mutation updatePassword($currentPassword: String!, $password: String!) {
  complete: updatePassword(currentPassword: $currentPassword, password: $password)
}
    `;
 const UpdateEmailDocument = gql`
    mutation updateEmail($email: String!) {
  complete: updateEmail(email: $email)
}
    `;
 const UpdateUserDocument = gql`
    mutation updateUser($data: UserUpdateInput!) {
  data: updateUser(data: $data)
}
    `;
 const CompleteCheckInDocument = gql`
    mutation completeCheckIn($data: GuestUpdateInput!) {
  data: completeCheckIn(data: $data)
}
    `;
 const UpdateCheckInDocument = gql`
    mutation updateCheckIn($data: CheckInUpdateInput!, $id: String!) {
  data: updateOneCheckIn(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const CheckInDocument = gql`
    mutation checkIn($churchId: String!, $courseId: String!, $email: String!, $sectionId: String!, $attribution: AttributionInput, $via: CheckInVia) {
  data: checkIn(
    churchId: $churchId
    courseId: $courseId
    email: $email
    sectionId: $sectionId
    attribution: $attribution
    via: $via
  ) {
    token
  }
}
    `;
 const GetCourseByUrlDocument = gql`
    query getCourseByUrl($courseUrl: String!, $churchUrl: String!, $date: DateTime) {
  church: findUniqueChurch(where: {url: $churchUrl}) {
    id
    name
    buttonColor
    buttonTextColor
    bannerColor
    buttonStyle
    bannerStyle
    logo
    url
    integrations {
      id
      type
      settings
    }
    publishedCourses: historicalCourses(where: {validity_upper: {gte: $date}}) {
      id
    }
    courses(where: {url: {equals: $courseUrl}}) {
      id
      name
      url
      brandingOverride
      sections(orderBy: {order: asc}) {
        id
        text
        name
        type
        order
        parentId
      }
    }
  }
}
    `;
 const GetChurchByUrlDocument = gql`
    query getChurchByUrl($churchUrl: String!, $date: DateTime) {
  church: findUniqueChurch(where: {url: $churchUrl}) {
    id
    name
    buttonColor
    buttonTextColor
    bannerColor
    buttonStyle
    bannerStyle
    logo
    url
    courses: historicalCourses(
      where: {public: {equals: true}, validity_upper: {gte: $date}}
      orderBy: {name: asc}
    ) {
      id
      name
      url
      description
    }
  }
}
    `;
 const GetActiveSubscriptionDocument = gql`
    query getActiveSubscription($churchId: String) {
  activeSubscription: activeSubscription(churchId: $churchId) {
    start
    end
  }
}
    `;
 const ChangeChurchDocument = gql`
    mutation changeChurch($churchId: String!) {
  data: changeChurch(churchId: $churchId) {
    token
  }
}
    `;
 const AutomationRunsForSectionDocument = gql`
    query automationRunsForSection($sectionId: String!, $skip: Int, $take: Int) {
  runs: automationRunsForSection(sectionId: $sectionId, skip: $skip, take: $take) {
    ...AutomationRunListFields
  }
}
    ${AutomationRunListFieldsFragmentDoc}`;
 const AutomationRunDocument = gql`
    query automationRun($id: String!) {
  run: automationRun(id: $id) {
    ...AutomationRunFields
  }
}
    ${AutomationRunFieldsFragmentDoc}`;
 const AutomationRunsForGuestDocument = gql`
    query automationRunsForGuest($guestId: String!) {
  runs: automationRunsForGuest(guestId: $guestId) {
    ...AutomationRunFields
  }
}
    ${AutomationRunFieldsFragmentDoc}`;
 const RetryAutomationRunDocument = gql`
    mutation retryAutomationRun($jobExecutionId: String!) {
  retryAutomationRun(jobExecutionId: $jobExecutionId)
}
    `;
 const FailedIntegrationSyncCountDocument = gql`
    query failedIntegrationSyncCount($type: String, $reason: String, $from: String, $to: String, $courseId: String) {
  failedIntegrationSyncCount(
    type: $type
    reason: $reason
    from: $from
    to: $to
    courseId: $courseId
  )
}
    `;
 const ResyncFailedIntegrationsDocument = gql`
    mutation resyncFailedIntegrations($types: [String], $reason: String, $from: String, $to: String, $courseId: String) {
  resyncFailedIntegrations(
    types: $types
    reason: $reason
    from: $from
    to: $to
    courseId: $courseId
  )
}
    `;
 const GetAutomationsDocument = gql`
    query getAutomations($id: String!, $churchId: String) {
  course: findUniqueCourse(where: {id: $id}) {
    id
    name
    url
    description
    public
    changed {
      id
    }
  }
  teams: findManyMinistry(where: {church: {id: {equals: "CHURCH_ID"}}}) {
    id
    name
    leaderName
    leaderEmail
  }
  activeSubscription: activeSubscription(churchId: $churchId) {
    start
    end
  }
}
    `;
 const GetAutomationSectionListDocument = gql`
    query getAutomationSectionList($courseId: String!) {
  sections: findManySection(
    where: {courseId: {equals: $courseId}}
    orderBy: {order: asc}
  ) {
    ...BasicSection
    automations {
      id
      label
      sendTo
      conditions
      integrationSource
      type
      values
      suppression {
        breakage
        daysBroken
        createdAt
      }
    }
    subSections(orderBy: {order: asc}) {
      id
      label
      text
      goTo
    }
  }
}
    ${BasicSectionFragmentDoc}`;
 const CreateAutomationDocument = gql`
    mutation createAutomation($data: AutomationCreateInput!) {
  automation: createOneAutomation(data: $data) {
    id
    label
    sendTo
    conditions
    integrationSource
    type
    values
  }
}
    `;
 const UpdateAutomationDocument = gql`
    mutation updateAutomation($data: AutomationUpdateInput!, $id: String!) {
  automation: updateOneAutomation(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const UpdateAutomationOrderDocument = gql`
    mutation updateAutomationOrder($data: SectionUpdateInput!, $id: String!) {
  data: updateOneSection(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const SelectPlanDocument = gql`
    mutation selectPlan($pricingId: String!, $backUrl: String) {
  url: selectPlan(pricingId: $pricingId, backUrl: $backUrl)
}
    `;
 const GetPlansDocument = gql`
    query getPlans {
  plans: findManyPricing(
    where: {available: {equals: true}}
    orderBy: {title: asc}
  ) {
    id
    title
    description
    bullets
    disclaimer
    displayPrice
    interval
    stripePricing
  }
}
    `;
 const GetPortalDocument = gql`
    query getPortal {
  portal: getPortal
}
    `;
 const GetCurrentPlanDocument = gql`
    query getCurrentPlan {
  plan: getCurrentPlan {
    id
    title
    displayPrice
    stripePricing
    interval
  }
}
    `;
 const GetSubscriptionDetailDocument = gql`
    query getSubscriptionDetail {
  subscription: getSubscriptionDetail {
    status
    currentPeriodStart
    currentPeriodEnd
    cancelAtPeriodEnd
    canceledAt
    interval
    billingMode
    checkInsUsed
    checkInPool
    checkInOverage
    overageAmountCents
    recommendedPlanId
    recommendedPlanTitle
    recommendedPlanPool
    scheduledChange {
      effectiveAt
      title
      displayPrice
      cancellable
    }
    pendingMigration {
      effectiveAt
      title
      displayPrice
      cancellable
    }
  }
}
    `;
 const CancelScheduledUpdateDocument = gql`
    mutation cancelScheduledUpdate {
  success: cancelScheduledUpdate
}
    `;
 const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($reason: String!, $feedback: String) {
  success: cancelSubscription(reason: $reason, feedback: $feedback)
}
    `;
 const ReactivateSubscriptionDocument = gql`
    mutation reactivateSubscription {
  success: reactivateSubscription
}
    `;
 const UpdatePlanDocument = gql`
    mutation updatePlan($pricingId: String!, $currentPricingId: String) {
  success: updatePlan(pricingId: $pricingId, currentPricingId: $currentPricingId)
}
    `;
 const ScheduleSubscriptionUpdateDocument = gql`
    mutation scheduleSubscriptionUpdate($pricingId: String!, $currentPricingId: String) {
  success: scheduleSubscriptionUpdate(
    pricingId: $pricingId
    currentPricingId: $currentPricingId
  )
}
    `;
 const GetPriceChangeDocument = gql`
    query getPriceChange($pricingId: String!, $currentPricingId: String) {
  data: getPriceChange(pricingId: $pricingId, currentPricingId: $currentPricingId) {
    amount
    date
  }
}
    `;
 const GetChurchSettingsDocument = gql`
    query getChurchSettings {
  data: findUniqueChurch(where: {id: "CHURCH_ID"}) {
    id
    name
    url
    timezone
    integrations {
      id
      type
      settings
      cachedData
    }
  }
}
    `;
 const UpdateChurchDocument = gql`
    mutation updateChurch($data: ChurchUpdateInput!) {
  data: updateOneChurch(where: {id: "CHURCH_ID"}, data: $data) {
    id
    name
    url
    timezone
    integrations {
      id
      type
      settings
      cachedData
    }
  }
}
    `;
 const CreateChurchDocument = gql`
    mutation createChurch($data: ChurchCreateInput!, $referralCode: String) {
  data: createOneChurch(data: $data, referralCode: $referralCode) {
    token
  }
}
    `;
 const GetInternalChurchesDocument = gql`
    query getInternalChurches($since: DateTime!) {
  churches: findManyChurch(orderBy: {createdAt: desc}) {
    id
    name
    createdAt
    customer
    demographics
    salesOwnerId
    salesAttributedAt
    salesVerifiedCall
    internalTags
    salesOwner {
      id
      firstName
      lastName
      email
    }
    users(where: {role: {equals: Owner}}) {
      role
      user {
        id
        firstName
        lastName
        email
      }
    }
    courses {
      id
      sections {
        id
      }
    }
  }
  checkIns: findManyCheckIn(
    where: {adminCheckIn: {equals: false}, startedAt: {gte: $since}}
  ) {
    id
    startedAt
    completedAt
    updatedAt
    courseId
  }
}
    `;
 const GetInternalDashboardDocument = gql`
    query getInternalDashboard {
  churches: findManyChurch(orderBy: {createdAt: desc}) {
    id
    name
    customer
    demographics
    createdAt
    salesOwnerId
    salesAttributedAt
    salesVerifiedCall
    internalTags
    salesOwner {
      id
      firstName
      lastName
      email
    }
  }
  billing: getAllBillingData {
    status
    plan
    checkins
    createdAt
    price
    endedAt
    customerId
    trialStart
    trialEnd
    interval
  }
  mrrTimeline: getMrrTimeline(months: 12) {
    month
    mrr
    newMrr
    lostMrr
    netDelta
    activeCount
  }
  billingChanges: getBillingChanges(daysBack: 30) {
    expansionMrr
    contractionMrr
    recoveredCount
    failedCount
    eventsScanned
    windowDays
  }
  reps: salesReps {
    id
    firstName
    lastName
    email
  }
  payouts: commissionPayouts {
    id
    salesUserId
    amountCents
    status
    periodStart
    periodEnd
  }
}
    `;
 const DeleteIntegrationDocument = gql`
    mutation deleteIntegration($id: String) {
  deleteOneIntegration(where: {id: $id}) {
    id
  }
}
    `;
 const GetUsersDocument = gql`
    query getUsers {
  users: findManyUser(
    where: {churches: {some: {churchId: {equals: "CHURCH_ID"}}}}
    orderBy: {firstName: asc}
  ) {
    id
    firstName
    lastName
    email
    churches {
      role
    }
  }
}
    `;
 const DeleteChurchUserDocument = gql`
    mutation deleteChurchUser($userId: String!) {
  deleteOneChurchToUser(
    where: {churchId_userId: {userId: $userId, churchId: "CHURCH_ID"}}
  ) {
    userId
    churchId
  }
}
    `;
 const InviteMemberDocument = gql`
    mutation inviteMember($email: String!) {
  user: inviteMember(email: $email) {
    id
    firstName
    lastName
    email
    churches {
      role
    }
  }
}
    `;
 const TransferOwnershipDocument = gql`
    mutation transferOwnership($toUserId: String!) {
  transferOwnership(toUserId: $toUserId)
}
    `;
 const ConsultingPackagesDocument = gql`
    query consultingPackages {
  consultingPackages {
    id
    name
    slug
    category
    description
    sessionsTotal
    sessionMinutes
    priceCents
    appliesWelcomeAboardCredit
    allowInstallments
    installmentMonths
  }
}
    `;
 const ConsultingStatusDocument = gql`
    query consultingStatus {
  consultingStatus {
    status
    packageName
    sessionsTotal
    sessionsUsed
    sessionsRemaining
    bookingUrl
    startedAt
    sessions {
      id
      scheduledAt
      status
    }
  }
}
    `;
 const StartConsultingCheckoutDocument = gql`
    mutation startConsultingCheckout($packageSlug: String!) {
  url: startConsultingCheckout(packageSlug: $packageSlug)
}
    `;
 const CreateCourseDocument = gql`
    mutation createCourse($data: CourseCreateInput!) {
  data: createOneCourse(data: $data) {
    id
  }
}
    `;
 const GetCourseDocument = gql`
    query getCourse($id: String!) {
  course: findUniqueCourse(where: {id: $id}) {
    id
    name
    url
    changed {
      id
    }
    sections(orderBy: {order: asc}) {
      id
      name
      order
      type
      courseId
      parentId
      settings
      childSections(orderBy: {order: asc}) {
        id
        name
        type
        settings
      }
    }
  }
}
    `;
 const GetCourseCheckInSectionDocument = gql`
    query getCourseCheckInSection($id: String!) {
  course: findUniqueCourse(where: {id: $id}) {
    id
    sections(where: {type: {equals: Checkin}}, orderBy: {order: asc}) {
      id
    }
  }
}
    `;
 const PublishCourseDocument = gql`
    mutation publishCourse($id: String!) {
  course: publishCourse(where: {id: $id}) {
    changed {
      id
    }
  }
}
    `;
 const GetCourseChangesDocument = gql`
    query getCourseChanges($id: String!) {
  course: findUniqueCourse(where: {id: $id}) {
    id
    changed {
      id
    }
  }
}
    `;
 const DeleteCourseDocument = gql`
    mutation deleteCourse($id: String!) {
  data: deleteOneCourse(where: {id: $id}) {
    id
  }
}
    `;
 const GetCoursesDocument = gql`
    query getCourses {
  courses: findManyCourse(where: {church: {id: {equals: "CHURCH_ID"}}}) {
    id
    name
    url
    createdAt
    changed {
      id
    }
    sections {
      id
    }
  }
  publishedCourses: findManyHistoricalCourse(
    where: {church: {id: {equals: "CHURCH_ID"}}}
  ) {
    id
  }
}
    `;
 const UpdateCourseDocument = gql`
    mutation updateCourse($data: CourseUpdateInput!, $id: String) {
  data: updateOneCourse(data: $data, where: {id: $id}) {
    id
    name
    url
    public
    description
    changed {
      id
    }
  }
}
    `;
 const SaveSubmissionDocument = gql`
    mutation saveSubmission($data: Json!, $sectionId: String!, $checkInId: String!) {
  submission: saveSectionSubmission(
    sectionId: $sectionId
    data: $data
    checkInId: $checkInId
  ) {
    id
    data
  }
}
    `;
 const DuplicateCourseDocument = gql`
    mutation duplicateCourse($id: String!) {
  data: duplicateCourse(id: $id) {
    id
  }
}
    `;
 const CreateMinistryDocument = gql`
    mutation createMinistry($data: MinistryCreateInput!) {
  data: createOneMinistry(data: $data) {
    id
    name
  }
}
    `;
 const GetMinistriesDocument = gql`
    query getMinistries {
  teams: findManyMinistry(
    where: {church: {id: {equals: "CHURCH_ID"}}}
    orderBy: {name: asc}
  ) {
    id
    name
    description
    leaderName
    leaderEmail
    createdAt
    _count {
      types
    }
  }
}
    `;
 const GetMinistryDocument = gql`
    query getMinistry($id: String!) {
  data: findUniqueMinistry(where: {id: $id}) {
    id
    name
    description
    leaderName
    leaderEmail
    leaderPhone
    types {
      id
    }
  }
  types: findManyTestResultType {
    id
    name
    shortDescription
    testType
  }
}
    `;
 const UpdateMinistryDocument = gql`
    mutation updateMinistry($data: MinistryUpdateInput!, $id: String!) {
  data: updateOneMinistry(data: $data, where: {id: $id}) {
    id
    name
    description
    leaderName
    leaderEmail
    leaderPhone
    types {
      id
    }
  }
}
    `;
 const GetTestDataDocument = gql`
    query getTestData($type: TestType) {
  questions: findManyTestQuestion(
    where: {testType: {equals: $type}}
    orderBy: {order: asc}
  ) {
    id
    question
    resultName
  }
  types: findManyTestResultType(where: {testType: {equals: $type}}) {
    id
    name
    additionalInfo
    type
  }
  attributes: findManyTestAttributes(
    where: {testType: {equals: $type}}
    orderBy: {order: asc}
  ) {
    id
    title
    value
    hint
    order
  }
}
    `;
 const GetAllTestDataDocument = gql`
    query getAllTestData {
  types: findManyTestResultType(orderBy: {name: asc}) {
    id
    name
    additionalInfo
    type
    testType
    ministries(where: {churchId: {equals: "CHURCH_ID"}}) {
      id
    }
  }
  questions: findManyTestQuestion(where: {order: {lte: 6}}, orderBy: {order: asc}) {
    id
    question
    resultName
    testType
  }
  attributes: findManyTestAttributes(orderBy: {order: asc}) {
    id
    title
    value
    hint
    order
    testType
  }
  teams: findManyMinistry(
    where: {churchId: {equals: "CHURCH_ID"}}
    orderBy: {name: asc}
  ) {
    id
    name
  }
}
    `;
 const GetTeamsDocument = gql`
    query getTeams {
  teams: findManyMinistry(
    where: {churchId: {equals: "CHURCH_ID"}}
    orderBy: {name: asc}
  ) {
    id
    name
    description
    _count {
      types
    }
  }
}
    `;
 const GetTestResultsDocument = gql`
    query getTestResults {
  results: findTestResults {
    id
    name
  }
  teams: findManyMinistry(
    where: {churchId: {equals: "GUEST_CHURCH_ID"}}
    orderBy: {name: asc}
  ) {
    id
    name
    description
  }
}
    `;
 const DeleteMinistryDocument = gql`
    mutation deleteMinistry($id: String!) {
  data: deleteOneMinistry(where: {id: $id}) {
    id
  }
}
    `;
 const EmailResultsDocument = gql`
    query emailResults($submissionId: String!, $header: String!, $items: String!) {
  emailed: emailResults(
    submissionId: $submissionId
    header: $header
    items: $items
  )
}
    `;
 const UpdateLinkMinistriesDocument = gql`
    mutation updateLinkMinistries($data: TestResultTypeUpdateInput!, $id: String!) {
  data: updateOneTestResultType(data: $data, where: {id: $id}) {
    id
    ministries(where: {churchId: {equals: "CHURCH_ID"}}) {
      id
    }
  }
}
    `;
 const GetMyReferralStatsDocument = gql`
    query getMyReferralStats {
  data: getMyReferralStats {
    code
    link
    referredThisYear
    capRemaining
    totalReferred
    totalEarnedCents
    pendingPayoutCount
  }
}
    `;
 const ListPendingReferralsDocument = gql`
    query listPendingReferrals {
  data: listPendingReferrals {
    id
    referrerUserId
    referredChurchId
    status
    rewardAmountCents
    paidAt
    tremendousOrderId
    notes
    createdAt
    referrer {
      id
      firstName
      lastName
      email
    }
    referredChurch {
      id
      name
      url
    }
  }
}
    `;
 const MarkReferralPaidDocument = gql`
    mutation markReferralPaid($id: String!, $tremendousOrderId: String, $notes: String) {
  data: markReferralPaid(
    id: $id
    tremendousOrderId: $tremendousOrderId
    notes: $notes
  ) {
    id
    status
    paidAt
    tremendousOrderId
  }
}
    `;
 const GetResourceArticlesDocument = gql`
    query getResourceArticles {
  articles: findManyResourceArticle(
    orderBy: {createdAt: desc}
    where: {type: {equals: ARTICLE}}
  ) {
    id
    title
    text
    image
    url
    type
    published
    createdAt
    author {
      id
      name
    }
    tags(take: 3) {
      id
      name
    }
  }
}
    `;
 const GetPublishedResourceArticlesDocument = gql`
    query getPublishedResourceArticles {
  articles: findManyResourceArticle(
    orderBy: {createdAt: desc}
    where: {type: {equals: ARTICLE}, published: {equals: true}}
  ) {
    id
    title
    image
    readTime
    url
    published
    createdAt
    author {
      id
      name
    }
    tags(take: 3) {
      id
      name
    }
  }
}
    `;
 const GetResourceDataDocument = gql`
    query getResourceData {
  tags: findManyResourceTag(
    orderBy: {createdAt: desc}
    where: {type: {equals: ARTICLE}}
  ) {
    id
    name
    url
  }
  authors: findManyResourceAuthor(orderBy: {createdAt: desc}) {
    id
    name
  }
}
    `;
 const GetResourceArticleDocument = gql`
    query getResourceArticle($url: String!) {
  article: findUniqueResourceArticle(where: {url: $url}) {
    id
    title
    image
    likes
    readTime
    text
    published
    createdAt
    author {
      id
      name
      image
      bio
    }
    tags {
      id
      name
    }
  }
  related: findManyResourceArticle(
    where: {url: {not: {equals: $url}}, tags: {some: {articles: {some: {url: {equals: $url}}}}}, type: {equals: ARTICLE}, published: {equals: true}}
    orderBy: {createdAt: desc}
    take: 3
  ) {
    id
    title
    image
    readTime
    url
    author {
      id
      name
    }
    tags(take: 3) {
      id
      name
    }
  }
}
    `;
 const CreateResourceDocument = gql`
    mutation createResource($data: ResourceArticleCreateInput!) {
  article: createOneResourceArticle(data: $data) {
    id
    title
    text
    image
    published
    url
    type
    createdAt
    author {
      id
      name
    }
    tags(take: 3) {
      id
      name
      url
    }
  }
}
    `;
 const UpdateResourceDocument = gql`
    mutation updateResource($data: ResourceArticleUpdateInput!, $id: String!) {
  article: updateOneResourceArticle(data: $data, where: {id: $id}) {
    id
    title
    text
    image
    published
    url
    type
    createdAt
    author {
      id
      name
    }
    tags(take: 3) {
      id
      name
    }
  }
}
    `;
 const DeleteArticleDocument = gql`
    mutation deleteArticle($id: String!) {
  data: deleteOneResourceArticle(where: {id: $id}) {
    id
  }
}
    `;
 const GetAllGuestsDocument = gql`
    query getAllGuests($cursor: GuestWhereUniqueInput, $orderBy: [GuestOrderByWithRelationInput], $skip: Int, $where: GuestWhereInput) {
  guests: findManyGuest(
    cursor: $cursor
    skip: $skip
    take: 20
    where: $where
    orderBy: $orderBy
  ) {
    id
    firstName
    lastName
    email
    checkIns(orderBy: {updatedAt: desc}) {
      id
      startedAt
      updatedAt
      completedAt
      sectionId
      adminCheckIn
      section {
        id
        name
      }
      course {
        id
        name
      }
    }
  }
  totalGuests: countGuest(where: $where)
}
    `;
 const GetGuestsByRecentActivityDocument = gql`
    query getGuestsByRecentActivity($skip: Int, $where: CheckInWhereInput, $guestWhere: GuestWhereInput, $orderBy: [CheckInOrderByWithRelationInput] = [{updatedAt: desc}]) {
  recentCheckIns: findManyCheckIn(
    skip: $skip
    take: 20
    where: $where
    orderBy: $orderBy
    distinct: guestId
  ) {
    guestId
    updatedAt
    guest {
      id
      firstName
      lastName
      email
      checkIns(orderBy: {updatedAt: desc}) {
        id
        startedAt
        updatedAt
        completedAt
        sectionId
        adminCheckIn
        courseId
      }
    }
  }
  totalGuests: countGuest(where: $guestWhere)
}
    `;
 const GetGuestDocument = gql`
    query getGuest($guestId: String!) {
  result: findUniqueGuest(where: {id: $guestId}) {
    firstName
    lastName
    email
    phone
    checkIns(orderBy: {updatedAt: desc}) {
      id
      startedAt
      updatedAt
      completedAt
      courseId
      submissions {
        id
        data
        sectionId
      }
      course {
        id
        name
        sections(orderBy: {order: asc}) {
          id
          name
          type
          text
          courseId
          settings
          inputs(orderBy: {order: asc}) {
            id
            type
            label
            required
            placeholder
            options
            order
          }
          questions(orderBy: {timecode: asc}) {
            id
            timecode
            message
            record
            type
          }
          subSections(orderBy: {order: asc}) {
            id
            label
            text
            order
            goTo
          }
        }
      }
    }
  }
}
    `;
 const GetResultCoursesDocument = gql`
    query getResultCourses {
  classes: findManyCourse(
    where: {church: {id: {equals: "CHURCH_ID"}}}
    orderBy: {createdAt: asc}
  ) {
    id
    name
  }
}
    `;
 const GetGuestCoursesDocument = gql`
    query getGuestCourses {
  classes: findManyCourse(
    where: {church: {id: {equals: "CHURCH_ID"}}}
    orderBy: {createdAt: asc}
  ) {
    id
    name
    sections(orderBy: {order: asc}) {
      id
      name
      type
      text
      courseId
      settings
      inputs(orderBy: {order: asc}) {
        id
        type
        label
        required
        placeholder
        options
        order
      }
      questions(orderBy: {timecode: asc}) {
        id
        timecode
        message
        record
        type
      }
      subSections(orderBy: {order: asc}) {
        id
        label
        text
        order
        goTo
      }
    }
  }
}
    `;
 const GetSalesRepsDocument = gql`
    query getSalesReps {
  reps: salesReps {
    id
    firstName
    lastName
    email
  }
}
    `;
 const GetChurchDetailDocument = gql`
    query getChurchDetail($churchId: String!) {
  church: findUniqueChurch(where: {id: $churchId}) {
    id
    name
    url
    createdAt
    customer
    demographics
    timezone
    salesOwnerId
    salesAttributedAt
    salesVerifiedCall
    internalTags
    salesOwner {
      id
      firstName
      lastName
      email
    }
    users {
      role
      user {
        id
        firstName
        lastName
        email
      }
    }
    courses {
      id
      name
      sections {
        id
      }
    }
  }
  notes: churchNotes(churchId: $churchId) {
    id
    body
    kind
    createdAt
    author {
      id
      firstName
      lastName
    }
  }
  reps: salesReps {
    id
    firstName
    lastName
    email
  }
}
    `;
 const GetChurchCheckInsDocument = gql`
    query getChurchCheckIns($churchId: String!, $days: Int) {
  buckets: churchCheckIns(churchId: $churchId, days: $days) {
    date
    count
  }
}
    `;
 const GetChurchNotesDocument = gql`
    query getChurchNotes($churchId: String!) {
  notes: churchNotes(churchId: $churchId) {
    id
    body
    kind
    createdAt
    author {
      id
      firstName
      lastName
    }
  }
}
    `;
 const GetSalesDashboardDocument = gql`
    query getSalesDashboard($salesUserId: String!) {
  payouts: commissionPayouts(salesUserId: $salesUserId) {
    id
    salesUserId
    periodStart
    periodEnd
    amountCents
    status
    paidAt
    notes
  }
  churches: findManyChurch(
    where: {salesOwnerId: {equals: $salesUserId}}
    orderBy: {createdAt: desc}
  ) {
    id
    name
    customer
    createdAt
    salesOwnerId
    salesAttributedAt
    salesVerifiedCall
  }
}
    `;
 const GetCommissionPayoutsDocument = gql`
    query getCommissionPayouts($salesUserId: String) {
  payouts: commissionPayouts(salesUserId: $salesUserId) {
    id
    salesUserId
    periodStart
    periodEnd
    amountCents
    status
    paidAt
    notes
    salesUser {
      id
      firstName
      lastName
    }
  }
}
    `;
 const SetChurchSalesOwnerDocument = gql`
    mutation setChurchSalesOwner($churchId: String!, $salesUserId: String) {
  church: setChurchSalesOwner(churchId: $churchId, salesUserId: $salesUserId) {
    id
    salesOwnerId
    salesAttributedAt
    salesVerifiedCall
    salesOwner {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
 const SetChurchVerifiedCallDocument = gql`
    mutation setChurchVerifiedCall($churchId: String!, $verified: Boolean!) {
  church: setChurchVerifiedCall(churchId: $churchId, verified: $verified) {
    id
    salesVerifiedCall
  }
}
    `;
 const SetChurchInternalTagsDocument = gql`
    mutation setChurchInternalTags($churchId: String!, $tags: [String!]!) {
  church: setChurchInternalTags(churchId: $churchId, tags: $tags) {
    id
    internalTags
  }
}
    `;
 const AddChurchNoteDocument = gql`
    mutation addChurchNote($churchId: String!, $body: String!) {
  note: addChurchNote(churchId: $churchId, body: $body) {
    id
    body
    kind
    createdAt
    author {
      id
      firstName
      lastName
    }
  }
}
    `;
 const UpsertCommissionPayoutDocument = gql`
    mutation upsertCommissionPayout($salesUserId: String!, $periodStart: DateTime!, $periodEnd: DateTime!, $amountCents: Int!, $notes: String) {
  payout: upsertCommissionPayout(
    salesUserId: $salesUserId
    periodStart: $periodStart
    periodEnd: $periodEnd
    amountCents: $amountCents
    notes: $notes
  ) {
    id
    amountCents
    status
    notes
  }
}
    `;
 const MarkCommissionPayoutPaidDocument = gql`
    mutation markCommissionPayoutPaid($id: String!) {
  payout: markCommissionPayoutPaid(id: $id) {
    id
    status
    paidAt
  }
}
    `;
 const GetSectionDocument = gql`
    query getSection($id: String!, $churchId: String) {
  currentSection: findUniqueSection(where: {id: $id}) {
    ...BasicSection
    childSections(orderBy: {order: asc}) {
      id
      type
      name
    }
    course {
      id
      name
      url
      description
      public
      changed {
        id
      }
    }
  }
  activeSubscription: activeSubscription(churchId: $churchId) {
    start
    end
  }
}
    ${BasicSectionFragmentDoc}`;
 const GetSectionListDocument = gql`
    query getSectionList($courseId: String!) {
  sections: findManySection(
    where: {courseId: {equals: $courseId}, parentId: {equals: null}}
    orderBy: {order: asc}
  ) {
    id
    name
    type
    order
    courseId
    parentId
    childSections(orderBy: {order: asc}) {
      id
      type
      name
    }
  }
}
    `;
 const GetCompletionCoursesDocument = gql`
    query getCompletionCourses($id: String!) {
  courses: findManyCourse(
    where: {church: {id: {equals: "CHURCH_ID"}}, id: {not: {equals: $id}}}
  ) {
    id
    name
  }
}
    `;
 const CreateSubSectionDocument = gql`
    mutation createSubSection($data: SubSectionCreateInput!) {
  sub: createOneSubSection(data: $data) {
    id
    label
    text
    order
    goTo
    section {
      id
      name
      type
      order
      courseId
      parentId
      childSections(orderBy: {order: asc}) {
        id
        type
        name
      }
    }
  }
}
    `;
 const UpdateSubSectionDocument = gql`
    mutation updateSubSection($data: SubSectionUpdateInput!, $id: String!) {
  section: updateOneSubSection(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const UpdateSubSectionOrderDocument = gql`
    mutation updateSubSectionOrder($data: SectionUpdateInput!, $id: String!) {
  data: updateOneSection(data: $data, where: {id: $id}) {
    id
    name
    type
    order
    courseId
    parentId
    childSections(orderBy: {order: asc}) {
      id
      type
      name
    }
    subSections(orderBy: {order: asc}) {
      id
    }
  }
}
    `;
 const CreateSectionDocument = gql`
    mutation createSection($data: SectionCreateInput!) {
  section: createOneSection(data: $data) {
    id
    name
    order
    type
    courseId
    childSections(orderBy: {order: asc}) {
      id
      name
      type
    }
  }
}
    `;
 const UpdateSectionDocument = gql`
    mutation updateSection($data: SectionUpdateInput!, $id: String!) {
  section: updateOneSection(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const UpdateCourseSectionOrderDocument = gql`
    mutation updateCourseSectionOrder($data: CourseUpdateInput!, $id: String!) {
  data: updateOneCourse(data: $data, where: {id: $id}) {
    sections(orderBy: {order: asc}) {
      id
    }
  }
}
    `;
 const DeleteSectionDocument = gql`
    mutation deleteSection($id: String!) {
  section: deleteOneSection(where: {id: $id}) {
    id
  }
}
    `;
 const DuplicateSectionDocument = gql`
    mutation duplicateSection($id: String!) {
  data: duplicateSection(id: $id) {
    id
    name
    type
    order
    courseId
    parentId
    childSections(orderBy: {order: asc}) {
      id
      type
      name
    }
  }
}
    `;
 const CreateInputDocument = gql`
    mutation createInput($data: FormInputCreateInput!) {
  input: createOneFormInput(data: $data) {
    id
    type
    label
    required
    placeholder
    options
    order
    createdAt
    updatedAt
  }
}
    `;
 const UpdateInputDocument = gql`
    mutation updateInput($data: FormInputUpdateInput!, $id: String!) {
  input: updateOneFormInput(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const UpdateInputOrderDocument = gql`
    mutation updateInputOrder($data: SectionUpdateInput!, $id: String!) {
  data: updateOneSection(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const CreateVideoQuestionDocument = gql`
    mutation createVideoQuestion($data: VideoQuestionsCreateInput!) {
  question: createOneVideoQuestions(data: $data) {
    id
    timecode
    message
    record
    type
    createdAt
    updatedAt
  }
}
    `;
 const UpdateVideoQuestionDocument = gql`
    mutation updateVideoQuestion($data: VideoQuestionsUpdateInput!, $id: String!) {
  question: updateOneVideoQuestions(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const DeleteVideoQuestionDocument = gql`
    mutation deleteVideoQuestion($id: String!) {
  data: deleteOneVideoQuestions(where: {id: $id}) {
    id
  }
}
    `;
 const CreateGoToCourseDocument = gql`
    mutation createGoToCourse($data: GoToCourseCreateInput!) {
  goTo: createOneGoToCourse(data: $data) {
    id
    label
    text
    order
    course {
      id
      name
      url
    }
  }
}
    `;
 const UpdateGoToCourseDocument = gql`
    mutation updateGoToCourse($data: GoToCourseUpdateInput!, $id: String!) {
  section: updateOneGoToCourse(data: $data, where: {id: $id}) {
    id
  }
}
    `;
 const UpdateGoToCourseOrderDocument = gql`
    mutation updateGoToCourseOrder($data: SectionUpdateInput!, $id: String!) {
  data: updateOneSection(data: $data, where: {id: $id}) {
    goToCourses(orderBy: {order: asc}) {
      id
    }
  }
}
    `;
 const GetSupportArticlesDocument = gql`
    query getSupportArticles {
  articles: findManyResourceArticle(
    orderBy: {createdAt: desc}
    where: {type: {equals: SUPPORT}}
  ) {
    id
    title
    text
    url
    likes
    type
    published
    updatedAt
    createdAt
    tags {
      id
      name
      url
    }
  }
}
    `;
 const GetSupportArticleByIdDocument = gql`
    query getSupportArticleById($id: String!) {
  article: findUniqueResourceArticle(where: {id: $id}) {
    id
    title
    text
    url
    likes
    type
    published
    updatedAt
    createdAt
    tags {
      id
      name
      url
    }
  }
}
    `;
 const GetPublishedSupportArticlesDocument = gql`
    query getPublishedSupportArticles($url: String!) {
  articles: findManyResourceArticle(
    orderBy: {createdAt: desc}
    where: {type: {equals: SUPPORT}, published: {equals: true}, tags: {some: {url: {equals: $url}}}}
  ) {
    id
    title
    url
  }
  tags: findManyResourceTag(
    orderBy: {createdAt: desc}
    where: {type: {equals: SUPPORT}}
  ) {
    id
    name
    url
    articles(where: {published: {equals: true}, type: {equals: SUPPORT}}) {
      id
      title
      url
    }
  }
}
    `;
 const GetSupportArticleDocument = gql`
    query getSupportArticle($url: String!) {
  article: findUniqueResourceArticle(where: {url: $url}) {
    id
    title
    text
    published
    tags {
      id
      name
      url
    }
  }
  tags: findManyResourceTag(
    orderBy: {createdAt: desc}
    where: {type: {equals: SUPPORT}}
  ) {
    id
    name
    url
    articles(where: {published: {equals: true}, type: {equals: SUPPORT}}) {
      id
      title
      url
    }
  }
}
    `;
 const GetSupportDataDocument = gql`
    query getSupportData {
  tags: findManyResourceTag(
    orderBy: {name: asc}
    where: {type: {equals: SUPPORT}}
  ) {
    id
    name
    url
  }
  authors: findManyResourceAuthor(orderBy: {name: asc}) {
    id
    name
  }
}
    `;
 const CopyWelcomeAboardTemplateDocument = gql`
    mutation copyWelcomeAboardTemplate {
  copyWelcomeAboardTemplate {
    courseId
    inPersonCourseId
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    me(variables?: MeQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'me', 'query');
    },
    guestChurch(variables?: GuestChurchQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GuestChurchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GuestChurchQuery>(GuestChurchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'guestChurch', 'query');
    },
    guestData(variables: GuestDataQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GuestDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GuestDataQuery>(GuestDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'guestData', 'query');
    },
    appSection(variables: AppSectionQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<AppSectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppSectionQuery>(AppSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'appSection', 'query');
    },
    login(variables: LoginMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'login', 'mutation');
    },
    signup(variables: SignupMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SignupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignupMutation>(SignupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signup', 'mutation');
    },
    forgotPassword(variables: ForgotPasswordMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ForgotPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForgotPasswordMutation>(ForgotPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forgotPassword', 'mutation');
    },
    captureLead(variables: CaptureLeadMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CaptureLeadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaptureLeadMutation>(CaptureLeadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'captureLead', 'mutation');
    },
    completeOnboarding(variables: CompleteOnboardingMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CompleteOnboardingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteOnboardingMutation>(CompleteOnboardingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeOnboarding', 'mutation');
    },
    requestMagicLink(variables: RequestMagicLinkMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<RequestMagicLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestMagicLinkMutation>(RequestMagicLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestMagicLink', 'mutation');
    },
    requestMagicLinkTo(variables: RequestMagicLinkToMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<RequestMagicLinkToMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestMagicLinkToMutation>(RequestMagicLinkToDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestMagicLinkTo', 'mutation');
    },
    loginWithMagicLink(variables: LoginWithMagicLinkMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<LoginWithMagicLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginWithMagicLinkMutation>(LoginWithMagicLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginWithMagicLink', 'mutation');
    },
    sendDesktopLink(variables?: SendDesktopLinkMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SendDesktopLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendDesktopLinkMutation>(SendDesktopLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendDesktopLink', 'mutation');
    },
    resetPassword(variables: ResetPasswordMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ResetPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetPasswordMutation>(ResetPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resetPassword', 'mutation');
    },
    updatePassword(variables: UpdatePasswordMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdatePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePasswordMutation>(UpdatePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePassword', 'mutation');
    },
    updateEmail(variables: UpdateEmailMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEmailMutation>(UpdateEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateEmail', 'mutation');
    },
    updateUser(variables: UpdateUserMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUser', 'mutation');
    },
    completeCheckIn(variables: CompleteCheckInMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CompleteCheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteCheckInMutation>(CompleteCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeCheckIn', 'mutation');
    },
    updateCheckIn(variables: UpdateCheckInMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateCheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCheckInMutation>(UpdateCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCheckIn', 'mutation');
    },
    checkIn(variables: CheckInMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckInMutation>(CheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkIn', 'mutation');
    },
    getCourseByUrl(variables: GetCourseByUrlQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCourseByUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourseByUrlQuery>(GetCourseByUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCourseByUrl', 'query');
    },
    getChurchByUrl(variables: GetChurchByUrlQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetChurchByUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChurchByUrlQuery>(GetChurchByUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChurchByUrl', 'query');
    },
    getActiveSubscription(variables?: GetActiveSubscriptionQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetActiveSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetActiveSubscriptionQuery>(GetActiveSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getActiveSubscription', 'query');
    },
    changeChurch(variables: ChangeChurchMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ChangeChurchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeChurchMutation>(ChangeChurchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeChurch', 'mutation');
    },
    automationRunsForSection(variables: AutomationRunsForSectionQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<AutomationRunsForSectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationRunsForSectionQuery>(AutomationRunsForSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'automationRunsForSection', 'query');
    },
    automationRun(variables: AutomationRunQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<AutomationRunQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationRunQuery>(AutomationRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'automationRun', 'query');
    },
    automationRunsForGuest(variables: AutomationRunsForGuestQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<AutomationRunsForGuestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationRunsForGuestQuery>(AutomationRunsForGuestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'automationRunsForGuest', 'query');
    },
    retryAutomationRun(variables: RetryAutomationRunMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<RetryAutomationRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RetryAutomationRunMutation>(RetryAutomationRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'retryAutomationRun', 'mutation');
    },
    failedIntegrationSyncCount(variables?: FailedIntegrationSyncCountQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<FailedIntegrationSyncCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FailedIntegrationSyncCountQuery>(FailedIntegrationSyncCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'failedIntegrationSyncCount', 'query');
    },
    resyncFailedIntegrations(variables?: ResyncFailedIntegrationsMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ResyncFailedIntegrationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResyncFailedIntegrationsMutation>(ResyncFailedIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resyncFailedIntegrations', 'mutation');
    },
    getAutomations(variables: GetAutomationsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetAutomationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAutomationsQuery>(GetAutomationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAutomations', 'query');
    },
    getAutomationSectionList(variables: GetAutomationSectionListQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetAutomationSectionListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAutomationSectionListQuery>(GetAutomationSectionListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAutomationSectionList', 'query');
    },
    createAutomation(variables: CreateAutomationMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAutomationMutation>(CreateAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAutomation', 'mutation');
    },
    updateAutomation(variables: UpdateAutomationMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAutomationMutation>(UpdateAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAutomation', 'mutation');
    },
    updateAutomationOrder(variables: UpdateAutomationOrderMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateAutomationOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAutomationOrderMutation>(UpdateAutomationOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAutomationOrder', 'mutation');
    },
    selectPlan(variables: SelectPlanMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SelectPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectPlanMutation>(SelectPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'selectPlan', 'mutation');
    },
    getPlans(variables?: GetPlansQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlansQuery>(GetPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlans', 'query');
    },
    getPortal(variables?: GetPortalQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetPortalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPortalQuery>(GetPortalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPortal', 'query');
    },
    getCurrentPlan(variables?: GetCurrentPlanQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCurrentPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrentPlanQuery>(GetCurrentPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCurrentPlan', 'query');
    },
    getSubscriptionDetail(variables?: GetSubscriptionDetailQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSubscriptionDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionDetailQuery>(GetSubscriptionDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSubscriptionDetail', 'query');
    },
    cancelScheduledUpdate(variables?: CancelScheduledUpdateMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CancelScheduledUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelScheduledUpdateMutation>(CancelScheduledUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelScheduledUpdate', 'mutation');
    },
    cancelSubscription(variables: CancelSubscriptionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CancelSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelSubscriptionMutation>(CancelSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelSubscription', 'mutation');
    },
    reactivateSubscription(variables?: ReactivateSubscriptionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ReactivateSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReactivateSubscriptionMutation>(ReactivateSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reactivateSubscription', 'mutation');
    },
    updatePlan(variables: UpdatePlanMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdatePlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePlanMutation>(UpdatePlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePlan', 'mutation');
    },
    scheduleSubscriptionUpdate(variables: ScheduleSubscriptionUpdateMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<ScheduleSubscriptionUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScheduleSubscriptionUpdateMutation>(ScheduleSubscriptionUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scheduleSubscriptionUpdate', 'mutation');
    },
    getPriceChange(variables: GetPriceChangeQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetPriceChangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPriceChangeQuery>(GetPriceChangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPriceChange', 'query');
    },
    getChurchSettings(variables?: GetChurchSettingsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetChurchSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChurchSettingsQuery>(GetChurchSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChurchSettings', 'query');
    },
    updateChurch(variables: UpdateChurchMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateChurchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateChurchMutation>(UpdateChurchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateChurch', 'mutation');
    },
    createChurch(variables: CreateChurchMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateChurchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateChurchMutation>(CreateChurchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createChurch', 'mutation');
    },
    getInternalChurches(variables: GetInternalChurchesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetInternalChurchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInternalChurchesQuery>(GetInternalChurchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInternalChurches', 'query');
    },
    getInternalDashboard(variables?: GetInternalDashboardQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetInternalDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInternalDashboardQuery>(GetInternalDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInternalDashboard', 'query');
    },
    deleteIntegration(variables?: DeleteIntegrationMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteIntegrationMutation>(DeleteIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteIntegration', 'mutation');
    },
    getUsers(variables?: GetUsersQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersQuery>(GetUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsers', 'query');
    },
    deleteChurchUser(variables: DeleteChurchUserMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteChurchUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteChurchUserMutation>(DeleteChurchUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteChurchUser', 'mutation');
    },
    inviteMember(variables: InviteMemberMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<InviteMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteMemberMutation>(InviteMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inviteMember', 'mutation');
    },
    transferOwnership(variables: TransferOwnershipMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<TransferOwnershipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TransferOwnershipMutation>(TransferOwnershipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'transferOwnership', 'mutation');
    },
    consultingPackages(variables?: ConsultingPackagesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<ConsultingPackagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultingPackagesQuery>(ConsultingPackagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultingPackages', 'query');
    },
    consultingStatus(variables?: ConsultingStatusQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<ConsultingStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultingStatusQuery>(ConsultingStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultingStatus', 'query');
    },
    startConsultingCheckout(variables: StartConsultingCheckoutMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<StartConsultingCheckoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartConsultingCheckoutMutation>(StartConsultingCheckoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'startConsultingCheckout', 'mutation');
    },
    createCourse(variables: CreateCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCourseMutation>(CreateCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCourse', 'mutation');
    },
    getCourse(variables: GetCourseQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCourseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourseQuery>(GetCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCourse', 'query');
    },
    getCourseCheckInSection(variables: GetCourseCheckInSectionQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCourseCheckInSectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourseCheckInSectionQuery>(GetCourseCheckInSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCourseCheckInSection', 'query');
    },
    publishCourse(variables: PublishCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<PublishCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishCourseMutation>(PublishCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'publishCourse', 'mutation');
    },
    getCourseChanges(variables: GetCourseChangesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCourseChangesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourseChangesQuery>(GetCourseChangesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCourseChanges', 'query');
    },
    deleteCourse(variables: DeleteCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCourseMutation>(DeleteCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCourse', 'mutation');
    },
    getCourses(variables?: GetCoursesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCoursesQuery>(GetCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCourses', 'query');
    },
    updateCourse(variables: UpdateCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCourseMutation>(UpdateCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCourse', 'mutation');
    },
    saveSubmission(variables: SaveSubmissionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SaveSubmissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSubmissionMutation>(SaveSubmissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveSubmission', 'mutation');
    },
    duplicateCourse(variables: DuplicateCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DuplicateCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateCourseMutation>(DuplicateCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateCourse', 'mutation');
    },
    createMinistry(variables: CreateMinistryMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateMinistryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMinistryMutation>(CreateMinistryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMinistry', 'mutation');
    },
    getMinistries(variables?: GetMinistriesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetMinistriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMinistriesQuery>(GetMinistriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMinistries', 'query');
    },
    getMinistry(variables: GetMinistryQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetMinistryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMinistryQuery>(GetMinistryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMinistry', 'query');
    },
    updateMinistry(variables: UpdateMinistryMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateMinistryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMinistryMutation>(UpdateMinistryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMinistry', 'mutation');
    },
    getTestData(variables?: GetTestDataQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetTestDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTestDataQuery>(GetTestDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTestData', 'query');
    },
    getAllTestData(variables?: GetAllTestDataQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetAllTestDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllTestDataQuery>(GetAllTestDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllTestData', 'query');
    },
    getTeams(variables?: GetTeamsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetTeamsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTeamsQuery>(GetTeamsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTeams', 'query');
    },
    getTestResults(variables?: GetTestResultsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetTestResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTestResultsQuery>(GetTestResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTestResults', 'query');
    },
    deleteMinistry(variables: DeleteMinistryMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteMinistryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMinistryMutation>(DeleteMinistryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMinistry', 'mutation');
    },
    emailResults(variables: EmailResultsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<EmailResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailResultsQuery>(EmailResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailResults', 'query');
    },
    updateLinkMinistries(variables: UpdateLinkMinistriesMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateLinkMinistriesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLinkMinistriesMutation>(UpdateLinkMinistriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLinkMinistries', 'mutation');
    },
    getMyReferralStats(variables?: GetMyReferralStatsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetMyReferralStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyReferralStatsQuery>(GetMyReferralStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyReferralStats', 'query');
    },
    listPendingReferrals(variables?: ListPendingReferralsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<ListPendingReferralsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListPendingReferralsQuery>(ListPendingReferralsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listPendingReferrals', 'query');
    },
    markReferralPaid(variables: MarkReferralPaidMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<MarkReferralPaidMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkReferralPaidMutation>(MarkReferralPaidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markReferralPaid', 'mutation');
    },
    getResourceArticles(variables?: GetResourceArticlesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetResourceArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetResourceArticlesQuery>(GetResourceArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getResourceArticles', 'query');
    },
    getPublishedResourceArticles(variables?: GetPublishedResourceArticlesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetPublishedResourceArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublishedResourceArticlesQuery>(GetPublishedResourceArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPublishedResourceArticles', 'query');
    },
    getResourceData(variables?: GetResourceDataQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetResourceDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetResourceDataQuery>(GetResourceDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getResourceData', 'query');
    },
    getResourceArticle(variables: GetResourceArticleQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetResourceArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetResourceArticleQuery>(GetResourceArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getResourceArticle', 'query');
    },
    createResource(variables: CreateResourceMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateResourceMutation>(CreateResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createResource', 'mutation');
    },
    updateResource(variables: UpdateResourceMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateResourceMutation>(UpdateResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateResource', 'mutation');
    },
    deleteArticle(variables: DeleteArticleMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteArticleMutation>(DeleteArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteArticle', 'mutation');
    },
    getAllGuests(variables?: GetAllGuestsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetAllGuestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllGuestsQuery>(GetAllGuestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllGuests', 'query');
    },
    getGuestsByRecentActivity(variables?: GetGuestsByRecentActivityQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetGuestsByRecentActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGuestsByRecentActivityQuery>(GetGuestsByRecentActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGuestsByRecentActivity', 'query');
    },
    getGuest(variables: GetGuestQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetGuestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGuestQuery>(GetGuestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGuest', 'query');
    },
    getResultCourses(variables?: GetResultCoursesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetResultCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetResultCoursesQuery>(GetResultCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getResultCourses', 'query');
    },
    getGuestCourses(variables?: GetGuestCoursesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetGuestCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGuestCoursesQuery>(GetGuestCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGuestCourses', 'query');
    },
    getSalesReps(variables?: GetSalesRepsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSalesRepsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSalesRepsQuery>(GetSalesRepsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSalesReps', 'query');
    },
    getChurchDetail(variables: GetChurchDetailQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetChurchDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChurchDetailQuery>(GetChurchDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChurchDetail', 'query');
    },
    getChurchCheckIns(variables: GetChurchCheckInsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetChurchCheckInsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChurchCheckInsQuery>(GetChurchCheckInsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChurchCheckIns', 'query');
    },
    getChurchNotes(variables: GetChurchNotesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetChurchNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChurchNotesQuery>(GetChurchNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getChurchNotes', 'query');
    },
    getSalesDashboard(variables: GetSalesDashboardQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSalesDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSalesDashboardQuery>(GetSalesDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSalesDashboard', 'query');
    },
    getCommissionPayouts(variables?: GetCommissionPayoutsQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCommissionPayoutsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCommissionPayoutsQuery>(GetCommissionPayoutsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCommissionPayouts', 'query');
    },
    setChurchSalesOwner(variables: SetChurchSalesOwnerMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SetChurchSalesOwnerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetChurchSalesOwnerMutation>(SetChurchSalesOwnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setChurchSalesOwner', 'mutation');
    },
    setChurchVerifiedCall(variables: SetChurchVerifiedCallMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SetChurchVerifiedCallMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetChurchVerifiedCallMutation>(SetChurchVerifiedCallDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setChurchVerifiedCall', 'mutation');
    },
    setChurchInternalTags(variables: SetChurchInternalTagsMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<SetChurchInternalTagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetChurchInternalTagsMutation>(SetChurchInternalTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setChurchInternalTags', 'mutation');
    },
    addChurchNote(variables: AddChurchNoteMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<AddChurchNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddChurchNoteMutation>(AddChurchNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addChurchNote', 'mutation');
    },
    upsertCommissionPayout(variables: UpsertCommissionPayoutMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpsertCommissionPayoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertCommissionPayoutMutation>(UpsertCommissionPayoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertCommissionPayout', 'mutation');
    },
    markCommissionPayoutPaid(variables: MarkCommissionPayoutPaidMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<MarkCommissionPayoutPaidMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkCommissionPayoutPaidMutation>(MarkCommissionPayoutPaidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markCommissionPayoutPaid', 'mutation');
    },
    getSection(variables: GetSectionQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSectionQuery>(GetSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSection', 'query');
    },
    getSectionList(variables: GetSectionListQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSectionListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSectionListQuery>(GetSectionListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSectionList', 'query');
    },
    getCompletionCourses(variables: GetCompletionCoursesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetCompletionCoursesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompletionCoursesQuery>(GetCompletionCoursesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCompletionCourses', 'query');
    },
    createSubSection(variables: CreateSubSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateSubSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubSectionMutation>(CreateSubSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSubSection', 'mutation');
    },
    updateSubSection(variables: UpdateSubSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateSubSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSubSectionMutation>(UpdateSubSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSubSection', 'mutation');
    },
    updateSubSectionOrder(variables: UpdateSubSectionOrderMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateSubSectionOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSubSectionOrderMutation>(UpdateSubSectionOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSubSectionOrder', 'mutation');
    },
    createSection(variables: CreateSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSectionMutation>(CreateSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSection', 'mutation');
    },
    updateSection(variables: UpdateSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSectionMutation>(UpdateSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSection', 'mutation');
    },
    updateCourseSectionOrder(variables: UpdateCourseSectionOrderMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateCourseSectionOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCourseSectionOrderMutation>(UpdateCourseSectionOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCourseSectionOrder', 'mutation');
    },
    deleteSection(variables: DeleteSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSectionMutation>(DeleteSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSection', 'mutation');
    },
    duplicateSection(variables: DuplicateSectionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DuplicateSectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateSectionMutation>(DuplicateSectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateSection', 'mutation');
    },
    createInput(variables: CreateInputMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateInputMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInputMutation>(CreateInputDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInput', 'mutation');
    },
    updateInput(variables: UpdateInputMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateInputMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInputMutation>(UpdateInputDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInput', 'mutation');
    },
    updateInputOrder(variables: UpdateInputOrderMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateInputOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInputOrderMutation>(UpdateInputOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInputOrder', 'mutation');
    },
    createVideoQuestion(variables: CreateVideoQuestionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateVideoQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVideoQuestionMutation>(CreateVideoQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVideoQuestion', 'mutation');
    },
    updateVideoQuestion(variables: UpdateVideoQuestionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateVideoQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVideoQuestionMutation>(UpdateVideoQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVideoQuestion', 'mutation');
    },
    deleteVideoQuestion(variables: DeleteVideoQuestionMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<DeleteVideoQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVideoQuestionMutation>(DeleteVideoQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVideoQuestion', 'mutation');
    },
    createGoToCourse(variables: CreateGoToCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CreateGoToCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGoToCourseMutation>(CreateGoToCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGoToCourse', 'mutation');
    },
    updateGoToCourse(variables: UpdateGoToCourseMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateGoToCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGoToCourseMutation>(UpdateGoToCourseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGoToCourse', 'mutation');
    },
    updateGoToCourseOrder(variables: UpdateGoToCourseOrderMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<UpdateGoToCourseOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGoToCourseOrderMutation>(UpdateGoToCourseOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGoToCourseOrder', 'mutation');
    },
    getSupportArticles(variables?: GetSupportArticlesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSupportArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSupportArticlesQuery>(GetSupportArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSupportArticles', 'query');
    },
    getSupportArticleById(variables: GetSupportArticleByIdQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSupportArticleByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSupportArticleByIdQuery>(GetSupportArticleByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSupportArticleById', 'query');
    },
    getPublishedSupportArticles(variables: GetPublishedSupportArticlesQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetPublishedSupportArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublishedSupportArticlesQuery>(GetPublishedSupportArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPublishedSupportArticles', 'query');
    },
    getSupportArticle(variables: GetSupportArticleQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSupportArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSupportArticleQuery>(GetSupportArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSupportArticle', 'query');
    },
    getSupportData(variables?: GetSupportDataQueryVariables, requestHeaders?: RequestInit["headers"]): Promise<GetSupportDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSupportDataQuery>(GetSupportDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSupportData', 'query');
    },
    copyWelcomeAboardTemplate(variables?: CopyWelcomeAboardTemplateMutationVariables, requestHeaders?: RequestInit["headers"]): Promise<CopyWelcomeAboardTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CopyWelcomeAboardTemplateMutation>(CopyWelcomeAboardTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'copyWelcomeAboardTemplate', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;